<nz-layout>
  <race-header [collapsed]="isCollapsed" (collapse)="toggleSidebar()" />

  @if (!isMobile()) {
    <nz-sider
      class="sidebar"
      nzBreakpoint="xl"
      nzCollapsible
      [nzCollapsedWidth]="55"
      [nzTrigger]="null"
      [nzWidth]="250"
      [(nzCollapsed)]="isCollapsed"
    >
      <race-sidebar [collapsed]="isCollapsed" />
    </nz-sider>
  } @else {
    <nz-drawer
      class="mobile-sidebar"
      nzPlacement="left"
      nzWidth="80%"
      [nzClosable]="true"
      [(nzVisible)]="drawerVisible"
      (nzOnClose)="closeDrawer()"
    >
      <ng-container *nzDrawerContent>
        <race-sidebar [collapsed]="false" />
      </ng-container>
    </nz-drawer>
  }
  <nz-content>
    <div class="inner-content">
      <router-outlet (activate)="onActivate($event)" />
    </div>
  </nz-content>
</nz-layout>
